export default {
  period: 'Период',
  today: 'Сегодня',
  yesterday: 'Вчера',
  tomorrow: 'Завтра',
  year: 'Год',
  month: 'Месяц',
  week: 'Неделя',
  lastWeek: 'Предыдущая неделя',
  nextWeek: 'Следующая неделя',
  overWeek: 'Следующая неделя',
  overMonth: 'Следующий месяц',
  overPeriod: 'Выбрать период...',
  threeDays: 'Следующие 3 дня',
  lastMonth: 'Предыдущий месяц',
  periodOff: 'Выключить период',
  dateStart: 'Дата начала',
  dateEnd: 'Дата окончания',
  closeDate: 'Дата закрытия',
  date: 'Дата',
};
